import { createBrowserRouter } from "react-router-dom";
import GeneralError from "./pages/errors/general-error";
import ProtectedRoute from "./components/ProtectedRoute";
import AppShell from "./components/app-shell";

// Public Routes
const publicRoutes = [
  {
    path: "/sign-in",
    lazy: async () => ({
      Component: (await import("./pages/auth/sign-in-2")).default,
    }),
  },
  {
    path: "/verify-user",
    lazy: async () => ({
      Component: (await import("./pages/auth/verify-user")).default,
    }),
  },
  {
    path: "/loginFactor",
    lazy: async () => ({
      Component: (await import("./pages/auth/two-factor-auth")).default,
    }),
  },
  {
    path: "/ForgotPassword",
    lazy: async () => ({
      Component: (await import("./pages/auth/forgot-password")).default,
    }),
  },
  {
    path: "/ResetPassword",
    lazy: async () => ({
      Component: (await import("./pages/auth/reset-password")).default,
    }),
  },
  {
    path: "branch-selection",
    lazy: async () => ({
      Component: (await import("@/pages/auth/branchSelection")).default,
    }),
  },
  {
    path: "/500",
    lazy: async () => ({
      Component: (await import("./pages/errors/general-error")).default,
    }),
  },
  {
    path: "/404",
    lazy: async () => ({
      Component: (await import('./pages/errors/not-found-error')).default,
    }),
  },
   {
    path: '/401',
    lazy: async () => ({
      Component: (await import('./pages/errors/unauthorized-error')).default,
    }),
  },
  // Fallback for undefined public routes
  {
    path: "*",
    lazy: async () => ({
      Component: (await import("./pages/errors/not-found-error")).default,
    }),
  },
];

// Private Routes
const privateRoutes = [
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <AppShell />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        lazy: async () => ({
          Component: (await import("./pages/dashboard")).default,
        }),
      },
      {
        path: "chats",
        lazy: async () => ({
          Component: (await import("@/components/coming-soon")).default,
        }),
      },
      {
        path: "apps",
        lazy: async () => ({
          Component: (await import("@/pages/apps")).default,
        }),
      },
      {
        path: "users",
        lazy: async () => ({
          Component: (await import("@/components/coming-soon")).default,
        }),
      },
      {
        path: "TwoFactor",
        lazy: async () => ({
          Component: (await import("@/pages/auth/two-factor-auth")).default,
        }),
      },
      {
        path: "lead",
        lazy: async () => ({
          Component: (await import("@/pages/Leader/view")).default,
        }),
      },
      {
        path: "country-view",
        lazy: async () => ({
          Component: (await import("@/pages/masters/parameter/country/view"))
            .default,
        }),
      },
      {
        path: "group-view",
        lazy: async () => ({
          Component: (await import("@/pages/masters/financial/group/view"))
            .default,
        }),
      },
      {
        path: "currency-view",
        lazy: async () => ({
          Component: (await import("@/pages/masters/product/currency/view"))
            .default,
        }),
      },
      {
        path: "currency-create",
        lazy: async () => ({
          Component: (await import("@/pages/masters/product/currency/create"))
            .default,
        }),
      },
      {
        path: "currency-edit",
        lazy: async () => ({
          Component: (await import("@/pages/masters/product/currency/edit"))
            .default,
        }),
      },
      {
        path: "product-view",
        lazy: async () => ({
          Component: (
            await import("@/pages/masters/product/product master/view")
          ).default,
        }),
      },
      {
        path: "product-create",
        lazy: async () => ({
          Component: (
            await import("@/pages/masters/product/product master/create")
          ).default,
        }),
      },
      {
        path: "product-edit",
        lazy: async () => ({
          Component: (
            await import("@/pages/masters/product/product master/edit")
          ).default,
        }),
      },
      {
        path: "evtm-for-surrender-view",
        lazy: async () => ({
          Component: (
            await import("@/pages/transactions/openings/evtmsurrender/view")
          ).default,
        }),
      },
      {
        path: "evtm-for-surrender-create",
        lazy: async () => ({
          Component: (
            await import("@/pages/transactions/openings/evtmsurrender/create")
          ).default,
        }),
      },
      {
        path: "evtm-for-surrender-edit",
        lazy: async () => ({
          Component: (
            await import("@/pages/transactions/openings/evtmsurrender/edit")
          ).default,
        }),
      },
      {
        path: "nature-of-business-view",
        lazy: async () => ({
          Component: (
            await import("@/pages/masters/risk/nature of business/view")
          ).default,
        }),
      },
      {
        path: "nature-of-business-create",
        lazy: async () => ({
          Component: (
            await import("@/pages/masters/risk/nature of business/create")
          ).default,
        }),
      },
      {
        path: "nature-of-business-edit",
        lazy: async () => ({
          Component: (
            await import("@/pages/masters/risk/nature of business/edit")
          ).default,
        }),
      },
      {
        path: "individual-walkin-customer-view",
        lazy: async () => ({
          Component: (await import("@/pages/masters/individual/view")).default,
        }),
      },
      {
        path: "individual-walkin-customer-create",
        lazy: async () => ({
          Component: (await import("@/pages/masters/individual/create"))
            .default,
        }),
      },
      {
        path: "individual-walkin-customer-edit",
        lazy: async () => ({
          Component: (await import("@/pages/masters/individual/edit")).default,
        }),
      },
      {
        path: "corporate-profile-customer-view",
        lazy: async () => ({
          Component: (
            await import("@/pages/masters/corporate/corporate profile/view")
          ).default,
        }),
      },
      {
        path: "corporate-profile-customer-create",
        lazy: async () => ({
          Component: (
            await import("@/pages/masters/corporate/corporate profile/create")
          ).default,
        }),
      },
      {
        path: "corporate-profile-customer-edit",
        lazy: async () => ({
          Component: (
            await import("@/pages/masters/corporate/corporate profile/edit")
          ).default,
        }),
      },
      {
        path: "vendor-Profile-view",
        lazy: async () => ({
          Component: (
            await import("@/pages/masters/vendor/vendor profile/view")
          ).default,
        }),
      },
      {
        path: "vendor-Profile-create",
        lazy: async () => ({
          Component: (
            await import("@/pages/masters/vendor/vendor profile/create")
          ).default,
        }),
      },
      {
        path: "vendor-Profile-edit",
        lazy: async () => ({
          Component: (
            await import("@/pages/masters/vendor/vendor profile/edit")
          ).default,
        }),
      },
      {
        path: "employee-profile-view",
        lazy: async () => ({
          Component: (
            await import("@/pages/masters/executive/employee profile/view")
          ).default,
        }),
      },
      {
        path: "employee-profile-create",
        lazy: async () => ({
          Component: (
            await import("@/pages/masters/executive/employee profile/create")
          ).default,
        }),
      },
      {
        path: "employee-profile-edit",
        lazy: async () => ({
          Component: (
            await import("@/pages/masters/executive/employee profile/edit")
          ).default,
        }),
      },
      {
        path: "rate-margin-view",
        lazy: async () => ({
          Component: (await import("@/pages/rates/rate master/view")).default,
        }),
      },
      {
        path: "rate-margin-create",
        lazy: async () => ({
          Component: (await import("@/pages/rates/rate master/create")).default,
        }),
      },
      {
        path: "rate-margin-edit",
        lazy: async () => ({
          Component: (await import("@/pages/rates/rate master/edit")).default,
        }),
      },
      {
        path: "sale-purchase-view",
        lazy: async () => ({
          Component: (await import("@/pages/rates/sale purchase/view")).default,
        }),
      },
      {
        path: "sale-purchase-create",
        lazy: async () => ({
          Component: (await import("@/pages/rates/sale purchase/create"))
            .default,
        }),
      },
      {
        path: "sale-purchase-edit",
        lazy: async () => ({
          Component: (await import("@/pages/rates/sale purchase/create"))
            .default,
        }),
      },
      {
        path: "vtm-surrender-view",
        lazy: async () => ({
          Component: (await import("@/pages/rates/vtm-surrender/view")).default,
        }),
      },
      {
        path: "vtm-surrender-create",
        lazy: async () => ({
          Component: (await import("@/pages/rates/vtm-surrender/create"))
            .default,
        }),
      },
      {
        path: "vtm-surrender-edit",
        lazy: async () => ({
          Component: (await import("@/pages/rates/vtm-surrender/edit")).default,
        }),
      },
      {
        path: "vtm-settlement-view",
        lazy: async () => ({
          Component: (await import("@/pages/rates/vtm-settlement/view"))
            .default,
        }),
      },
      {
        path: "vtm-settlement-create",
        lazy: async () => ({
          Component: (await import("@/pages/rates/vtm-settlement/create"))
            .default,
        }),
      },
      {
        path: "vtm-settlement-edit",
        lazy: async () => ({
          Component: (await import("@/pages/rates/vtm-settlement/edit"))
            .default,
        }),
      },
      {
        path: "rate-master-view",
        lazy: async () => ({
          Component: (await import("@/pages/rates/rate common/view")).default,
        }),
      },
      {
        path: "rate-master-create",
        lazy: async () => ({
          Component: (await import("@/pages/rates/rate common/create")).default,
        }),
      },
      {
        path: "rate-master-edit",
        lazy: async () => ({
          Component: (await import("@/pages/rates/rate common/edit")).default,
        }),
      },
      {
        path: "common-type-view",
        lazy: async () => ({
          Component: (await import("@/pages/configuration/common type/view"))
            .default,
        }),
      },
      {
        path: "common-type-create",
        lazy: async () => ({
          Component: (await import("@/pages/configuration/common type/create"))
            .default,
        }),
      },
      {
        path: "common-type-edit",
        lazy: async () => ({
          Component: (await import("@/pages/configuration/common type/edit"))
            .default,
        }),
      },
      {
        path: "common-master-view",
        lazy: async () => ({
          Component: (await import("@/pages/configuration/common master/view"))
            .default,
        }),
      },
      {
        path: "common-master-create",
        lazy: async () => ({
          Component: (
            await import("@/pages/configuration/common master/create")
          ).default,
        }),
      },
      {
        path: "common-master-edit",
        lazy: async () => ({
          Component: (await import("@/pages/configuration/common master/edit"))
            .default,
        }),
      },
      {
        path: "branch-view",
        lazy: async () => ({
          Component: (await import("@/pages/masters/branches/view")).default,
        }),
      },
      {
        path: "branch-create",
        lazy: async () => ({
          Component: (await import("@/pages/masters/branches/create")).default,
        }),
      },
      {
        path: "branch-edit",
        lazy: async () => ({
          Component: (await import("@/pages/masters/branches/edit")).default,
        }),
      },
      {
        path: "sale-to-public",
        lazy: async () => ({
          Component: (await import("@/pages/transactions/sales/view")).default,
        }),
      },
      {
        path: "sale-to-public-create",
        lazy: async () => ({
          Component: (await import("@/pages/transactions/sales/create"))
            .default,
        }),
      },
      {
        path: "sale-to-public-edit",
        lazy: async () => ({
          Component: (await import("@/pages/transactions/sales/create"))
            .default,
        }),
      },
      {
        path: "sale-bulk",
        lazy: async () => ({
          Component: (await import("@/pages/transactions/sale-bulk/view"))
            .default,
        }),
      },
      {
        path: "sale-bulk-create",
        lazy: async () => ({
          Component: (await import("@/pages/transactions/sale-bulk/create"))
            .default,
        }),
      },
      {
        path: "sale-bulk-edit",
        lazy: async () => ({
          Component: (await import("@/pages/transactions/sale-bulk/create"))
            .default,
        }),
      },
      {
        path: "purchase-bulk",
        lazy: async () => ({
          Component: (await import("@/pages/transactions/purchase-bulk/view"))
            .default,
        }),
      },
      {
        path: "purchase-bulk-create",
        lazy: async () => ({
          Component: (await import("@/pages/transactions/purchase-bulk/create"))
            .default,
        }),
      },
      {
        path: "purchase-bulk-edit",
        lazy: async () => ({
          Component: (await import("@/pages/transactions/purchase-bulk/create"))
            .default,
        }),
      },
      // {
      //   path: 'sale-bulk',
      //   lazy: async () => ({
      //     Component: (await import('@/pages/transactions/salebulk/view')).default,
      //   }),
      // },
      // {
      //   path: 'sale-bulk-create',
      //   lazy: async () => ({
      //     Component: (await import('@/pages/transactions/salebulk/create')).default,
      //   }),
      // },
      // {
      //   path: 'sale-bulk-edit',
      //   lazy: async () => ({
      //     Component: (await import('@/pages/transactions/salebulk/edit')).default,
      //   }),
      // },
      {
        path: "purchase-from-public",
        lazy: async () => ({
          Component: (await import("@/pages/transactions/purchase/view"))
            .default,
        }),
      },
      {
        path: "purchase-from-public-create",
        lazy: async () => ({
          Component: (await import("@/pages/transactions/purchase/create"))
            .default,
        }),
      },
      {
        path: "purchase-from-public-edit/",
        lazy: async () => ({
          Component: (await import("@/pages/transactions/purchase/edit"))
            .default,
        }),
      },
      {
        path: 'currency-out',
        lazy: async () => ({
          Component: (await import('@/pages/transactions/stock transfer/currency-out/view')).default,
        }),
      },
      {
        path: 'currency-out-create',
        lazy: async () => ({
          Component: (await import('@/pages/transactions/stock transfer/currency-out/create')).default,
        }),
      },
      {
        path: 'currency-out-edit',
        lazy: async () => ({
          Component: (await import('@/pages/transactions/stock transfer/currency-out/create')).default,
        }),
      },
      {
        path: 'currency-in',
        lazy: async () => ({
          Component: (await import('@/pages/transactions/stock transfer/currency-in/view')).default,
        }),
      },
      {
        path: 'currency-in-create',
        lazy: async () => ({
          Component: (await import('@/pages/transactions/stock transfer/currency-in/create')).default,
        }),
      },
      {
        path: 'currency-in-edit',
        lazy: async () => ({
          Component: (await import('@/pages/transactions/stock transfer/currency-in/create')).default,
        }),
      },
      {
        path: 'group-master-view',
        lazy: async () => ({
          Component: (await import('@/pages/Accounts/group master/view')).default,
        }),
      },
      {
        path: 'tenant-Create',
        lazy: async () => ({
          Component: (await import('@/pages/Admin/tenant/create')).default,
        }),
      },
      {
        path: 'tenant-View',
        lazy: async () => ({
          Component: (await import('@/pages/Admin/tenant/view')).default,
        }),
      },
      {
        path: 'tenant-Edit',
        lazy: async () => ({
          Component: (await import('@/pages/Admin/tenant/edit')).default,
        }),
      },
      {
        path: 'role-Create',
        lazy: async () => ({
          Component: (await import('@/pages/Admin/role/create')).default,
        }),
      },
      {
        path: 'role-View',
        lazy: async () => ({
          Component: (await import('@/pages/Admin/role/view')).default,
        }),
      },
      {
        path: 'role-Edit',
        lazy: async () => ({
          Component: (await import('@/pages/Admin/role/edit')).default,
        }),
      },
      {
        path: 'side-Create',
        lazy: async () => ({
          Component: (await import('@/pages/Admin/sidebar/create')).default,
        }),
      },
      {
        path: 'side-View',
        lazy: async () => ({
          Component: (await import('@/pages/Admin/sidebar/view')).default,
        }),
      },
      {
        path: 'side-Edit',
        lazy: async () => ({
          Component: (await import('@/pages/Admin/sidebar/edit')).default,
        }),
      },
      {
        path: 'feature-Create',
        lazy: async () => ({
          Component: (await import('@/pages/Admin/feature/create')).default,
        }),
      },
      {
        path: 'feature-Edit',
        lazy: async () => ({
          Component: (await import('@/pages/Admin/feature/edit')).default,
        }),
      },
      {
        path: 'user-Create',
        lazy: async () => ({
          Component: (await import('@/pages/Admin/user/create')).default,
        }),
      },
      {
        path: 'user-View',
        lazy: async () => ({
          Component: (await import('@/pages/Admin/user/view')).default,
        }),
      },
      {
        path: 'user-Edit',
        lazy: async () => ({
          Component: (await import('@/pages/Admin/user/edit')).default,
        }),
      },
      {
        path: 'ledger-view',
        lazy: async () => ({
          Component: (await import('@/pages/Accounts/ledger/view')).default,
        }),
      },
      {
        path: 'ledger-create',
        lazy: async () => ({
          Component: (await import('@/pages/Accounts/ledger/create')).default,
        }),
      },
      {
        path: 'ledger-edit',
        lazy: async () => ({
          Component: (await import('@/pages/Accounts/ledger/edit')).default,
        }),
      },
      {
        path: 'opening-balance-view',
        lazy: async () => ({
          Component: (await import('@/pages/Accounts/openingbalance/view')).default,
        }),
      },

      {
        path: "tenant-Create",
        lazy: async () => ({
          Component: (await import("@/pages/Admin/tenant/create")).default,
        }),
      },
      {
        path: "tenant-View",
        lazy: async () => ({
          Component: (await import("@/pages/Admin/tenant/view")).default,
        }),
      },
      {
        path: "tenant-Edit",
        lazy: async () => ({
          Component: (await import("@/pages/Admin/tenant/edit")).default,
        }),
      },
      {
        path: "role-Create",
        lazy: async () => ({
          Component: (await import("@/pages/Admin/role/create")).default,
        }),
      },
      {
        path: "role-View",
        lazy: async () => ({
          Component: (await import("@/pages/Admin/role/view")).default,
        }),
      },
      {
        path: "role-Edit",
        lazy: async () => ({
          Component: (await import("@/pages/Admin/role/edit")).default,
        }),
      },
      {
        path: "side-Create",
        lazy: async () => ({
          Component: (await import("@/pages/Admin/sidebar/create")).default,
        }),
      },
      {
        path: "side-View",
        lazy: async () => ({
          Component: (await import("@/pages/Admin/sidebar/view")).default,
        }),
      },
      {
        path: "side-Edit",
        lazy: async () => ({
          Component: (await import("@/pages/Admin/sidebar/edit")).default,
        }),
      },
      {
        path: "feature-Create",
        lazy: async () => ({
          Component: (await import("@/pages/Admin/feature/create")).default,
        }),
      },
      {
        path: "feature-Edit",
        lazy: async () => ({
          Component: (await import("@/pages/Admin/feature/edit")).default,
        }),
      },
      {
        path: "user-Create",
        lazy: async () => ({
          Component: (await import("@/pages/Admin/user/create")).default,
        }),
      },
      {
        path: "user-View",
        lazy: async () => ({
          Component: (await import("@/pages/Admin/user/view")).default,
        }),
      },
      {
        path: "user-Edit",
        lazy: async () => ({
          Component: (await import("@/pages/Admin/user/edit")).default,
        }),
      },
      {
        path: "bank-view",
        lazy: async () => ({
          Component: (await import("@/pages/masters/Bank/view")).default,
        }),
      },
      {
        path: "bank-create",
        lazy: async () => ({
          Component: (await import("@/pages/masters/Bank/create")).default,
        }),
      },
      {
        path: "bank-edit",
        lazy: async () => ({
          Component: (await import("@/pages/masters/Bank/edit")).default,
        }),
      },
      {
        path: "bankdetail-view",
        lazy: async () => ({
          Component: (await import("@/pages/masters/Bank/BankDetails/view"))
            .default,
        }),
      },
      {
        path: "bankdetail-create",
        lazy: async () => ({
          Component: (await import("@/pages/masters/Bank/BankDetails/create"))
            .default,
        }),
      },
      {
        path: "bankdetail-edit",
        lazy: async () => ({
          Component: (await import("@/pages/masters/Bank/BankDetails/edit"))
            .default,
        }),
      },
      {
        path: "cpedit",
        lazy: async () => ({
          Component: (await import("@/pages/Leader/view")).default,
        }),
        errorElement: <GeneralError />,
        children: [
          {
            index: true,
            lazy: async () => ({
              Component: (await import("./pages/settings/profile")).default,
            }),
          },
          {
            path: "account",
            lazy: async () => ({
              Component: (await import("./pages/settings/account")).default,
            }),
          },
          {
            path: "appearance",
            lazy: async () => ({
              Component: (await import("./pages/settings/appearance")).default,
            }),
          },
          {
            path: "notifications",
            lazy: async () => ({
              Component: (await import("./pages/settings/notifications"))
                .default,
            }),
          },
          {
            path: "display",
            lazy: async () => ({
              Component: (await import("./pages/settings/display")).default,
            }),
          },
          {
            path: "error-example",
            lazy: async () => ({
              Component: (await import("./pages/settings/error-example"))
                .default,
            }),
          },
          {
            path: "*",
            lazy: async () => ({
              Component: (await import("./pages/errors/not-found-error"))
                .default,
            }),
          },
        ],
      },
      {
        path: "*",
        lazy: async () => ({
          Component: (await import("./pages/errors/not-found-error")).default,
        }),
      },
      {
        path: "tenant-Create",
        lazy: async () => ({
          Component: (await import("@/pages/Admin/tenant/create")).default,
        }),
      },
      {
        path: "tenant-View",
        lazy: async () => ({
          Component: (await import("@/pages/Admin/tenant/view")).default,
        }),
      },
      {
        path: "tenant-Edit",
        lazy: async () => ({
          Component: (await import("@/pages/Admin/tenant/edit")).default,
        }),
      },
      {
        path: "role-Create",
        lazy: async () => ({
          Component: (await import("@/pages/Admin/role/create")).default,
        }),
      },
      {
        path: "role-View",
        lazy: async () => ({
          Component: (await import("@/pages/Admin/role/view")).default,
        }),
      },
      {
        path: "role-Edit",
        lazy: async () => ({
          Component: (await import("@/pages/Admin/role/edit")).default,
        }),
      },
      {
        path: "side-Create",
        lazy: async () => ({
          Component: (await import("@/pages/Admin/sidebar/create")).default,
        }),
      },
      {
        path: "user-Create",
        lazy: async () => ({
          Component: (await import("@/pages/Admin/user/create")).default,
        }),
      },
      {
        path: "user-View",
        lazy: async () => ({
          Component: (await import("@/pages/Admin/user/view")).default,
        }),
      },
      {
        path: "user-Edit",
        lazy: async () => ({
          Component: (await import("@/pages/Admin/user/edit")).default,
        }),
      },
      {
        path: "financial-year-view",
        lazy: async () => ({
          Component: (
            await import("@/pages/Accounts/financial year master/view")
          ).default,
        }),
      },
      {
        path: "financial-year-edit",
        lazy: async () => ({
          Component: (
            await import("@/pages/Accounts/financial year master/edit")
          ).default,
        }),
      },
      {
        path: "financial-year-create",
        lazy: async () => ({
          Component: (
            await import("@/pages/Accounts/financial year master/create")
          ).default,
        }),
      },
      {
        path: "vouchertype-view",
        lazy: async () => ({
          Component: (await import("@/pages/Accounts/VoucherType/view"))
            .default,
        }),
      },
      {
        path: "vouchertype-edit",
        lazy: async () => ({
          Component: (await import("@/pages/Accounts/VoucherType/edit"))
            .default,
        }),
      },
      {
        path: "vouchertype-create",
        lazy: async () => ({
          Component: (await import("@/pages/Accounts/VoucherType/create"))
            .default,
        }),
      },
      {
        path: "currencystock-view",
        lazy: async () => ({
          Component: (
            await import("@/pages/transactions/openings/currency stock/view")
          ).default,
        }),
      },
      {
        path: "vtcin-view",
        lazy: async () => ({
          Component: (await import("@/pages/transactions/vtc in/view")).default,
        }),
      },
      {
        path: "vtcin-edit",
        lazy: async () => ({
          Component: (await import("@/pages/transactions/vtc in/edit")).default,
        }),
      },
      {
        path: "vtcin-create",
        lazy: async () => ({
          Component: (await import("@/pages/transactions/vtc in/create"))
            .default,
        }),
      },
      {
        path: "vtcout-view",
        lazy: async () => ({
          Component: (await import("@/pages/transactions/vtc out/view"))
            .default,
        }),
      },
      {
        path: "vtcout-edit",
        lazy: async () => ({
          Component: (await import("@/pages/transactions/vtc out/edit"))
            .default,
        }),
      },
      {
        path: "vtcout-create",
        lazy: async () => ({
          Component: (await import("@/pages/transactions/vtc out/create"))
            .default,
        }),
      },
      {
        path: "evtmsurrender-view",
        lazy: async () => ({
          Component: (await import("@/pages/transactions/evtmsurrender/view"))
            .default,
        }),
      },
      {
        path: "evtmsurrender-edit",
        lazy: async () => ({
          Component: (await import("@/pages/transactions/evtmsurrender/edit"))
            .default,
        }),
      },
      {
        path: "evtmsurrender-create",
        lazy: async () => ({
          Component: (await import('@/pages/transactions/evtmsurrender/create')).default,
        }),
      },
      {
        path: 'evtmsettlement-view',
        lazy: async () => ({
          Component: (await import('@/pages/transactions/evtmsettlement/view')).default,
        }),
      },
      {
        path: 'evtmsettlement-edit',
        lazy: async () => ({
          Component: (await import('@/pages/transactions/evtmsettlement/edit')).default,
        }),
      },
      {
        path: 'evtmsettlement-create',
        lazy: async () => ({
          Component: (await import('@/pages/transactions/evtmsettlement/create')).default,
        }),
      },
       {
        path: "purchase-invoice-view",
        lazy: async () => ({
          Component: (await import("@/pages/transactions/invoice/view"))
            .default,
        }),
      },
      {
        path: "purchase-invoice-create",
        lazy: async () => ({
          Component: (await import("@/pages/transactions/invoice/create"))
            .default,
        }),
      },
      {
        path: "purchase-invoice-edit",
        lazy: async () => ({
          Component: (await import("@/pages/transactions/invoice/edit"))
            .default,
        }),
      },
       {
        path: 'voucher-view',
        lazy: async () => ({
          Component: (await import('@/pages/Accounts/voucher/view')).default,
        }),
      },
      {
        path: 'voucher-edit',
        lazy: async () => ({
          Component: (await import('@/pages/Accounts/voucher/edit')).default,
        }),
      },
      {
        path: 'voucher-create',
        lazy: async () => ({
          Component: (await import('@/pages/Accounts/voucher/create')).default,
        }),
      },
      {
        path: 'sale-invoice-view',
        lazy: async () => ({
          Component: (await import('@/pages/transactions/invoice-sales/view')).default,
        }),
      },
      {
        path: 'sale-invoice-create',
        lazy: async () => ({
          Component: (await import('@/pages/transactions/invoice-sales/create')).default,
        }),
      },
      {
        path: 'sale-invoice-edit',
        lazy: async () => ({
          Component: (await import('@/pages/transactions/invoice-sales/edit')).default,
        }),
      },
      {
        path: 'report-View',
        lazy: async () => ({
          Component: (await import('@/pages/Report/report')).default,
        }),
      },
      {
        path: 'reportfeature-Create',
        lazy: async () => ({
          Component: (await import('@/pages/Admin/reportfeature/create')).default,
        }),
      },
      {
        path: 'reportfeature-Edit',
        lazy: async () => ({
          Component: (await import('@/pages/Admin/feature/edit')).default,
        }),
      },
      {
        path: 'reports-Create',
        lazy: async () => ({
          Component: (await import('@/pages/Admin/Report/create')).default,
        }),
      },
      {
        path: 'reports-View',
        lazy: async () => ({
          Component: (await import('@/pages/Admin/Report/view')).default,
        }),
      },
      {
        path: 'reports-Edit',
        lazy: async () => ({
          Component: (await import('@/pages/Admin/Report/edit')).default,
        }),
      },
      {
        path: 'bill-printing-view',
        lazy: async () => ({
          Component: (await import('@/pages/transactions/bill-printing/view')).default,
        }),
      },
    ],
  },
];

const router = createBrowserRouter([...publicRoutes, ...privateRoutes]);

export default router;
